import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestTracking } from '../../../helpers/adipiBackendUrl';
import { getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTTRACKING,
  DELETE_LABREQUESTTRACKING,
  GET_LABREQUESTTRACKINGS,
  UPDATE_LABREQUESTTRACKING
} from "./actionTypes";
import {
  addLabRequestTrackingFail,
  addLabRequestTrackingSuccess,
  deleteLabRequestTrackingFail,
  deleteLabRequestTrackingSuccess,
  getLabRequestTrackingsFail,
  getLabRequestTrackingsSuccess,
  setState,
  updateLabRequestTrackingFail,
  updateLabRequestTrackingSuccess,
} from "./actions";


//Include Both Helper File with needed methods

function* fetchLabRequestTrackings( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, labRequestTracking, params.toString());
    yield put(setState(false))
    yield put(getLabRequestTrackingsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestTrackingsFail(error));
  }
}

function* updateLabRequestTracking ({payload: labRequestTrackingObj }) {
  let silent = false;
  try {
    const { id, silent: silentVal, ...rest } = labRequestTrackingObj;
    silent = silentVal;
    yield call(patchApiCall, `${labRequestTracking}/${id}`, rest);
    const response = yield call(getTable,`${labRequestTracking}/${id}`);
    yield put(updateLabRequestTrackingSuccess(response));
    if (!silent) {
      toast.success('Registro actualizado correctamente')
    }
  } catch (error) {
    yield put(updateLabRequestTrackingFail(error));
    if (!silent) {
      toast.error('Error al actualizar el registro')
    }
  }
}

function* updateLabRequestTrackingStatus ({payload: labRequestTrackingObj }) {
  try {
    const response = yield call(getTable,`${labRequestTracking}/${labRequestTrackingObj.id}`);
    yield put(updateLabRequestTrackingSuccess(response));
  } catch (error) {
    yield put(updateLabRequestTrackingFail(error));
  }
}

function* deleteLabRequestTracking ({payload: labRequestTrackingObj}) {
  try {
    yield put(deleteLabRequestTrackingSuccess(labRequestTrackingObj.id));
    toast.success('Registro borrado correctamente')

  } catch (error) {
    yield put(deleteLabRequestTrackingFail(error));
    toast.error('Error al borrar el registro')

  }
}

function* postingLabRequestTracking ({ payload: labRequestTracking}) {
  try {
    const response = yield call(postApiCall, labRequestTracking ,labRequestTracking);
    const response1 = yield call(getTable,`${labRequestTracking}/${response.id}`);
    yield put(addLabRequestTrackingSuccess(response1));
    toast.success('Registro agregado correctamente')

  } catch (error) {
    yield put(addLabRequestTrackingFail(error));
    toast.error('Error al agregar el registro')

  }
}

function* labRequestTrackingsSaga() {
  yield takeEvery(GET_LABREQUESTTRACKINGS, fetchLabRequestTrackings);
  yield takeEvery(ADD_NEW_LABREQUESTTRACKING, postingLabRequestTracking);
  yield takeEvery(UPDATE_LABREQUESTTRACKING, updateLabRequestTracking);
  yield takeEvery(UPDATE_LABREQUESTTRACKING, updateLabRequestTrackingStatus);
  yield takeEvery(DELETE_LABREQUESTTRACKING, deleteLabRequestTracking);
}

export default labRequestTrackingsSaga;
